export const CASE_STUDIES = {
  FORTIFY: 'fortify',
} as const;

export type CaseStudyName = (typeof CASE_STUDIES)[keyof typeof CASE_STUDIES];
